import {useQuery} from '@tanstack/react-query'

import {Api} from '../../../../../api'
import {Equipment} from '../../../types/equipment'

import {useUrlParam} from '@settings/modules/routing'

export const QueryKey = 'equipment'

export const useGetEquipment = () => {
  const plantCode = useUrlParam('plantCode')
  return useQuery({
    queryKey: [QueryKey, plantCode],
    queryFn: async () => {
      const path = `upm/equipment/plant/${plantCode}?pageSize=100000`
      return (await Api.axiosInstance.get<Equipment[]>(path)).data
    },
    staleTime: Infinity
  })
}
